<template>
    <div>
        <v-dialog
            v-model="showDialogMap"
            transition="dialog-top-transition"
            persistent
            width="80%"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card
                flat
                tile
            >
                <v-card-title class="text-h6 frontdesk d-flex justify-space-between">
                    <div>
                        <v-icon left class="pipelineIconTitle">mdi mdi-map-marker</v-icon>
                        <label class="pipelineLabelTitle">Map</label>
                    </div>
                </v-card-title>

                <v-card-text 
                    style="margin-top: 20px;"
                    class="pipelineDetails"
                >
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <label>Latitude</label>
                            <v-text-field
                                v-model="locationData.latitude"
                                single-line
                                outlined
                                dense
                                @change="updateMap()"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col 
                            cols="12"
                            lg="3"
                            md="4"
                            sm="12"
                        >
                            <label>Longitude</label>
                            <v-text-field
                                v-model="locationData.longitude"
                                single-line
                                outlined
                                dense
                                @change="updateMap()"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <div style="width: 100%; height: 50vh" id="mapView"></div>
                        </v-col>
                    </v-row>
                </v-card-text>

				<v-divider></v-divider>

				<v-card-actions style="padding: 15px !important;">
					<div style="width: 100%; text-align: center;">
						<v-btn
							class="mx-2 dialogButtonDismiss v-btn-large"
							outlined
							@click="dismiss"
						>
							Dismiss
						</v-btn>
                        <v-btn
                            class="mx-2 v-btn-large"
                            outlined
                            @click="sendUpdateLocation"
                        >
                            Update Location
                        </v-btn>
					</div>
				</v-card-actions>

            </v-card>
        </v-dialog> 
	</div>
</template>

<script>

    import Helpers from '@/utilities/Helpers';

	export default {

        mixins: [Helpers],

        props: {
			
            idAux: {
                type: Number,
                default: 0
            },
			
            address: {
                type: String,
                default: ''
            },
			
            latitude: {
                type: String,
                default: ''
            },
			
            longitude: {
                type: String,
                default: ''
            },

			showDialogMap: {
				default: false
			},
		},

        watch: {
            async "idAux"() {
                await this.getLocation();
            },
        },

        data: () => ({
            locationData: {
                latitude: '',
                longitude: ''
            },

            latitudeLocal: '',
            map: null
		}),

        methods: {

            async getLocation() {

                if (this.latitude != '' && this.latitude != null && this.longitude != '' && this.longitude != null) {
                    this.locationData = {
                        latitude: this.latitude,
                        longitude: this.longitude
                    };
                } 
                else {
                    const addressRequest = {
                        address: this.address
                    }
                    const response = await this.$store.dispatch("customerModule/GetLatitudeLongitude", addressRequest);
                    if (response) {
                        this.locationData = {
                            latitude: response.latitude,
                            longitude: response.longitude
                        };
                    }
                }

                setTimeout(async () => {
                    await this.updateMap();
                }, 500);
            },
            
            async updateMap() {

                if (this.locationData != null) {

                    if (this.map != null) {
                        this.map.remove();
                        this.map = null;
                    }

                    const L = window.L; // Garante que Leaflet está disponível

                    // Verifica se o elemento existe antes de iniciar o mapa
                    if (document.getElementById("mapView")) {
                        this.map = L.map("mapView").setView(
                            [this.locationData.latitude, this.locationData.longitude], 
                            11
                        );

                        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                            attribution: '&copy; OpenStreetMap contributors'
                        }).addTo(this.map);

                        // Adiciona todos os marcadores
                        const marker = L.marker([this.locationData.latitude, this.locationData.longitude], { draggable: true }).addTo(this.map)
                            .bindPopup(`<b>${this.address}</b>`);

                        marker.on('dragend', () => {
                            const pos = marker.getLatLng();
                            this.locationData = {
                                latitude: pos.lat.toString(),
                                longitude: pos.lng.toString()
                            };
                        });
                    }
                }
            },

            sendUpdateLocation() {
                this.$emit('methodConfirmToCall', this.locationData);
                this.$emit('update:showDialogMap', false);
            },

            dismiss() {
                this.$emit('methodConfirmToCall');
                this.$emit('update:showDialogMap', false);
            },
        },
    };
</script>

<style scoped>

    label {
        font-size: 14px !important;
        color: #5e5e5e;
    }

    .pipelineDetails {
        margin-top: 15px;
    }

    .pipelineIconTitle {
        color: white !important;
    }

    .pipelineLabelTitle {
        color: white !important;
        font-size: 17px;
    }

    .frontdesk {
        background-color: var(--color__construction_dashboard_predig);
    }

</style>